<table class="selected-tickets-table">
  <thead>
    <tr>
      <th scope="col" class="first-column">{{ 'fgbcl.selected.tickets.table.card.number' | translate }}</th>
      <th *ngIf="ticketColumn1 !== ticketDetails.Hide" scope="col">{{ 'fgbcl.selected.tickets.table.area' | translate }}</th>
      <th *ngIf="ticketColumn2 !== ticketDetails.Hide" scope="col">
        {{ 'fgbcl.selected.tickets.table.card.section' | translate }}
      </th>
      <th scope="col" *ngIf="hasRow$ | async">{{ 'fgbcl.selected.tickets.table.row' | translate }}</th>
      <th scope="col" class="col-seat">{{ 'fgbcl.selected.tickets.table.seat' | translate }}</th>
      <th scope="col" class="remove-button-column" *ngIf="showRemoveButton"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let ticket of selectedTickets$ | async">
      <td class="fw-bold text-primary first-column" scope="row">{{ ticket.ACN }}</td>
      <td *ngIf="ticketColumn1 !== ticketDetails.Hide">
        <ng-container [ngSwitch]="ticketColumn1">
          <span *ngSwitchCase="ticketDetails.AreaLine1">{{ ticket.AreaLine1 }}</span>
          <span *ngSwitchCase="ticketDetails.Stand">{{ ticket.Stand }}</span>
          <span *ngSwitchCase="ticketDetails.StandName">{{ ticket.StandName }}</span>
          <span *ngSwitchDefault>{{ ticket.Area }}</span>
        </ng-container>
      </td>
      <td *ngIf="ticketColumn2 !== ticketDetails.Hide">
        <ng-container [ngSwitch]="ticketColumn2">
          <span *ngSwitchCase="ticketDetails.AreaLine1">{{ ticket.AreaLine1 }}</span>
          <span *ngSwitchCase="ticketDetails.Area">{{ ticket.Area }}</span>
          <span *ngSwitchCase="ticketDetails.StandName">{{ ticket.StandName }}</span>
          <span *ngSwitchDefault>{{ ticket.Stand }}</span>
        </ng-container>
      </td>
      <td *ngIf="ticket.Row">{{ ticket.Row }}</td>
      <td>{{ ticket.Seat }}</td>
      <td *ngIf="showRemoveButton">
        <button class="remove-ticket" (click)="remove(ticket.Id)" aria-label="Remove ticket">X</button>
      </td>
    </tr>
  </tbody>
</table>
